import { createSupabaseClient } from '@pharmaconnect/api'

const url = import.meta.env.VITE_SUPABASE_URL ?? ''
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY ?? ''

if (!url || !anonKey) {
  // eslint-disable-next-line no-console
  console.warn('VITE_SUPABASE_URL / VITE_SUPABASE_ANON_KEY manquants — vérifier .env')
}

export const supabase = createSupabaseClient({ url, anonKey })
